import servise from '@/router/axios'

export const setShow = (data) => {
  return servise({
    url: '/report/show',
    method: 'PUT',
    data,
    timeout: 1800000000
  })
}

export const deduction = (data) => {
  return servise({
    url: '/report/deduction',
    method: 'put',
    data
  })
}

export const ledgerImport = (data) => {
  return servise({
    url: '/report/ledger/import/data',
    method: 'POST',
    data
  })
}

export const getSchedule = () => {
  return servise({
    url: '/report/show/schedule',
    method: 'get',
    params:{}
  })
}

export const setSynch = (data) => {
  return servise({
    url: '/report/synchronization/data',
    method: 'PUT',
    data,
    timeout:600000
  })
}